export default __webpack_public_path__ + "static/media/kitchen3-afterB-1440w.43961997.avif";